import * as angular from 'angular';
import {IController} from 'angular';
import {VehicleStatusChangeReasonSettingsEntity} from "../../models/vehicle-status-change-reason-settings.model";
import {SettingsService} from "../../services/settings-service.service";

export class VehicleStatusChangeReasonSelectListComponent implements IController {


  selectedId: any;
  ngPlaceholder: any;
  onChange: Function;

  public vehicleStatusChangeReasons: VehicleStatusChangeReasonSettingsEntity[];

  /* @ngInject */
  constructor(private settingsService: SettingsService) {
  }

  $onInit() {
    this.settingsService.getAllVehicleStatusChangeReason()
      .then((vehicleStatusChangeReasons: VehicleStatusChangeReasonSettingsEntity[]) => {
        this.vehicleStatusChangeReasons = vehicleStatusChangeReasons;
      })
  }
}

angular
  .module('bringoz.admin.site-preferences')
  .component('vehicleStatusChangeReasonSelectList', {
    bindings: {
      selectedId: '<',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./vehicle-status-change-reason-select-list.html').default,
    controller: VehicleStatusChangeReasonSelectListComponent
  });
